import { createContext } from 'react'
import type { UseChatWindowReturn } from './hooks/useChatWindow'

export type ChatWindowContextValue = UseChatWindowReturn

export const ChatWindowContext = createContext<ChatWindowContextValue | null>(null)
